import { chatIdentifierFromKey, chatIdentifierToKey, SafeMap, } from "@shared";
import {} from "./undo";
export class LocalMap {
    serialiser;
    deserialiser;
    #queue = [];
    constructor(serialiser, deserialiser) {
        this.serialiser = serialiser;
        this.deserialiser = deserialiser;
    }
    // for testing
    addedOrUpdated(key) {
        return this.#queue.find((m) => m.kind === "add" && m.key === key) !== undefined;
    }
    // for testing
    removed(key) {
        return this.#queue.find((m) => m.kind === "remove" && m.key === key) !== undefined;
    }
    // used for testing
    clear() {
        this.#queue = [];
    }
    addOrUpdate(key, value) {
        const add = { kind: "add", key, value };
        this.#queue.push(add);
        return () => {
            this.#queue = this.#queue.filter((a) => a !== add);
        };
    }
    // This is very rarely needed - you probably don't need this
    undoRemove(key) {
        this.#queue = this.#queue.filter((m) => !(m.kind === "remove" && m.key === key));
        return () => { };
    }
    remove(key) {
        const remove = { kind: "remove", key };
        this.#queue.push(remove);
        return () => {
            this.#queue = this.#queue.filter((a) => a !== remove);
        };
    }
    apply(original) {
        if (this.#queue.length === 0)
            return original;
        // only the last modification for each key has any effect
        const last = new SafeMap(this.serialiser, this.deserialiser);
        for (const mod of this.#queue) {
            last.set(mod.key, mod);
        }
        const merged = new SafeMap(this.serialiser, this.deserialiser);
        for (const [k, v] of original) {
            merged.set(k, v);
        }
        for (const [, mod] of last) {
            if (mod.kind === "remove") {
                merged.delete(mod.key);
            }
            if (mod.kind === "add") {
                merged.set(mod.key, mod.value);
            }
        }
        return merged;
    }
}
export class LocalCommunityMap extends LocalMap {
    constructor() {
        super((id) => id.communityId, (k) => ({ kind: "community", communityId: String(k) }));
    }
}
export class LocalChatMap extends LocalMap {
    constructor() {
        super((id) => chatIdentifierToKey(id), (k) => chatIdentifierFromKey(String(k)));
    }
}
